import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";

@Injectable({
  providedIn: "root"
})
export class VehicleService {
  constructor(private apiService: ApiService) {}

  getVehicleTypeList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.vehicleType, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getAccessibilityList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.accessibility, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getDriverVehicleList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.vehicle, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getVehicleBrandList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.vehicleBrand, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getVehicleModelsList(parameters: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.vehicleModel, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  addVehicle(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = apiColletions.vehicle;
      this.apiService.post({ url: url, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  updateVehicle(vehicleId: string, parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.vehicle}/${vehicleId}`;
      this.apiService.put({ url: url, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  assignVehicle(vehicleId: string, parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.assignVehicle}/${vehicleId}`;
      this.apiService.put({ url: url, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getCancellationPolicy(vehicleId: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.vehicleTypeCancellationPolicy}/${vehicleId}`;
      this.apiService.get({ url: url, parameters: {} }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
